import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

import { formatCurrencyBr } from '../../utils/parseValorMoeda';

const formatCurrency = formatCurrencyBr;

const fmtPct = (v) => (v == null ? '' : `${v > 0 ? '+' : ''}${v}%`);

export default function TrilhaContratoEvolucaoChart({ pontos = [], numeroContrato, empresa }) {
  if (!pontos.length) {
    return (
      <Typography variant="body2" color="text.secondary" textAlign="center" py={3}>
        Sem dados para gráfico de evolução.
      </Typography>
    );
  }

  const chartData = pontos.map((p, idx) => ({
    ...p,
    idx,
    labelCurta: p.label,
  }));

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={700} gutterBottom>
        Evolução do valor/mês — {numeroContrato}
      </Typography>
      {empresa && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {empresa}
        </Typography>
      )}

      <Box sx={{ width: '100%', height: 340, mb: 3 }}>
        <ResponsiveContainer>
          <LineChart data={chartData} margin={{ top: 16, right: 24, left: 8, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.06)" />
            <XAxis
              dataKey="labelCurta"
              tick={{ fontSize: 11, fill: '#546e7a' }}
              axisLine={{ stroke: 'rgba(0,0,0,0.12)' }}
            />
            <YAxis
              tick={{ fontSize: 11, fill: '#546e7a' }}
              tickFormatter={(v) =>
                v >= 1000 ? `R$ ${(v / 1000).toFixed(1)}k` : `R$ ${v}`
              }
            />
            <Tooltip
              formatter={(value) => [formatCurrency(value), 'Valor/mês']}
              labelFormatter={(_, payload) => {
                const p = payload?.[0]?.payload;
                if (!p) return '';
                return `${p.label} · ${p.vigenciaInicio || ''}${p.vigenciaFim ? ` → ${p.vigenciaFim}` : ''}`;
              }}
              contentStyle={{
                borderRadius: 12,
                border: '1px solid rgba(25,118,210,0.2)',
              }}
            />
            <Line
              type="monotone"
              dataKey="valorMes"
              stroke="#1976d2"
              strokeWidth={2.5}
              dot={{ r: 6, fill: '#1976d2', strokeWidth: 2, stroke: '#fff' }}
              activeDot={{ r: 8 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: 'rgba(25,118,210,0.06)' }}>
              <TableCell>Etapa</TableCell>
              <TableCell>Vigência início</TableCell>
              <TableCell>Vigência fim</TableCell>
              <TableCell align="right">Valor/mês</TableCell>
              <TableCell align="right">Variação</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pontos.map((p) => (
              <TableRow key={p.label}>
                <TableCell>{p.label}</TableCell>
                <TableCell>{p.vigenciaInicio || '—'}</TableCell>
                <TableCell>{p.vigenciaFim || '—'}</TableCell>
                <TableCell align="right">{formatCurrency(p.valorMes)}</TableCell>
                <TableCell align="right">{fmtPct(p.variacaoPercentual) || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
